export default {
  onboarding: import.meta.env.VITE_WALKFIT_ONBOARDING,
  termsOfUse: 'https://legal.walkfit.pro/page/terms-of-use',
  privacyPolicy: 'https://legal.walkfit.pro/page/privacy-policy',
  refundPolicy: 'https://legal.walkfit.pro/page/refund-policy',
};
